export const footerContent = {
  contact: "+91-8169010728",
  email: "careers@intelegain.com",
};
